import { render, staticRenderFns } from "./QuantumTunnelingViz.vue?vue&type=template&id=1c86a64a&scoped=true"
import script from "./QuantumTunnelingViz.vue?vue&type=script&lang=js"
export * from "./QuantumTunnelingViz.vue?vue&type=script&lang=js"
import style0 from "./QuantumTunnelingViz.vue?vue&type=style&index=0&id=1c86a64a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c86a64a",
  null
  
)

export default component.exports